import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import 'remeeting-css/semantic/dist/semantic.min.css';

import Create from './create';
import NoMatch from './nomatch';
import Forgot from './forgot';
import SignIn from './signin';
import SignOut from './signout';
import UnauthenticatedRoute from './unauthenticated-route';
import Verify from './verify';

import { setRmiAuth } from '../modules/session';

import '../stylesheets/auth.css';

class App extends Component {
  constructor(props) {
    super(props);
    const { connectedSetRmiAuth } = props;
    connectedSetRmiAuth();
  }

  render() {
    return (
      <div className="re is-full-height auth">
        <Switch>
          <UnauthenticatedRoute exact path="/create" component={Create} routeName="Create Account" routeActionDescription="create a new account" />
          <UnauthenticatedRoute exact path="/forgot" component={Forgot} routeName="Forgot Password?" routeActionDescription="change your password" />
          <UnauthenticatedRoute exact path="/signin" component={SignIn} routeName="Sign In" routeActionDescription="sign in to another account" />
          <Route exact path="/signout" component={SignOut} routeName="Sign Out" routeActionDescription="sign out of your account" />
          <UnauthenticatedRoute exact path="/verify/:token/:email" component={Verify} routeName="Set Password" routeActionDescription="set a new password" />
          <Route component={NoMatch} />
        </Switch>
      </div>
    );
  }
}

App.propTypes = {
  connectedSetRmiAuth: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedSetRmiAuth: setRmiAuth,
}, dispatch);

export default withRouter(connect(undefined, mapDispatchToProps)(App));
